import { Component, NgZone, ChangeDetectorRef, Input, OnInit, SimpleChange } from '@angular/core';
import { environment } from '../../../environments/environment';
//import { DOCUMENT } from '@angular/common'; 
import { Injectable } from '@angular/core';
import { olMapEventService } from '../../shared/services/olEventEmitter.service';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements  OnInit {

  imagepath: string;
  selectedTabb: string = "day";
  @Input() selectedId: number;
  @Input() dayurl: string;
  @Input() weekurl: string;
  @Input() monthurl: string;
  @Input() seasonurl: string;  

  constructor(private olmapselection: olMapEventService, private ngzone: NgZone, private changedetectorref:ChangeDetectorRef) {
    this.imagepath = environment.serverUrl + 'FrostMeasurements/Graph/';
  }

  ngOnInit(): void {
    if (this.olmapselection.subsVar == undefined) {
      this.olmapselection.subsVar = this.olmapselection.invokeMapSelection.subscribe((maetpunktId: number) => {
        this.selectedId = maetpunktId;
        console.log('UpdateGraphs: ' + maetpunktId.toString());
        this.updateGraphs(maetpunktId);
      });
    }   
  }

  tabChanged(tabId: string) {
    this.selectedTabb = tabId;
  }

  public updateGraphs(maetpunktid: number) {
    this.selectedId = maetpunktid;
    var date = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(date.getDate() + 1);

    var monthdate = new Date();
    monthdate.setDate(date.getDate() - 31);

    var seasondate = new Date();
    seasondate.setDate(date.getDate() - 31 * 9);

    var toDate = this.getformattedDate(tomorrow);
    var fromdate = this.getformattedDate(new Date());
    this.dayurl = this.imagepath + maetpunktid.toString() + '/' + fromdate + '/' + toDate+'?time='+ new Date().getTime()

    var weekdate = new Date();
    weekdate.setDate(date.getDate() - 7);
    fromdate = this.getformattedDate(weekdate);
    this.weekurl = this.imagepath + maetpunktid.toString() + '/' + fromdate + '/' + toDate+'?time='+ new Date().getTime()

    var monthdate = new Date();
    monthdate.setDate(date.getDate() - 31);
    fromdate = this.getformattedDate(monthdate);
    this.monthurl = this.imagepath + maetpunktid.toString() + '/' + fromdate + '/' + toDate+'?time='+ new Date().getTime()

    var seasondate = new Date();
    seasondate.setDate(date.getDate() - 31 * 9);
    fromdate = this.getformattedDate(seasondate);
    this.seasonurl = this.imagepath + maetpunktid.toString() + '/' + fromdate + '/' + toDate+'?time='+ new Date().getTime()

    this.changedetectorref.detectChanges(); 
    console.log('updateGrahps körd');
  }

  private setStationlist(parameters) {
    var tabId = parameters.tab;
    var id = parameters.id;
    var fromDate = parameters.from;
    var toDate = parameters.to;
    // document.getElementById(tabId+'list').innerHTML='nu hamnade vi här' + new Date().toLocaleDateString();
  }

  public getformattedDate(currentTime: Date) {
    var formattedDate = currentTime.getFullYear().toString();
    var value = (currentTime.getMonth() + 1).toString();
    formattedDate += '00'.substr(0, 2 - value.length) + value;

    value = currentTime.getDate().toString();;
    formattedDate += '00'.substr(0, 2 - value.length) + value;
    return formattedDate;
  }
}

